<template>
  <div>
    <MasterLayout>
      <div class="pt-5 pb-3 pl-4 pr-3 dashboard_first_row">
        <div class="row">
          <div class="col-md-8">
            <div class="py-5 pt-5 mb-3 row align-items-center white-bg">
              <div class="col-md-1 remove-right-padding col-center-flex">
                <div class="square-icon-wrapper small sky-bg">
                  <img src="@/assets/img/supply-chain.png" width="40px" />
                </div>
              </div>
              <div class="py-1 col-md-7">
                <h4 class="primary-color font-600">
                  {{ $t("text.sales.manageDryStock") }}
                </h4>
                <p class="mt-3 light-grey-text">
                  {{ $t("text.sales.dryStockSupplies") }}
                </p>
              </div>
              <!-- <div class="col-md-4 flexify">
                  <router-link
                    :to="{ name: 'CreateNonWetProductSupply', query: {companyId: $route.query.companyId}}"
                    class="mr-3 btn dealers_btn"
                    >Add supply
                </router-link>
              </div> -->
            </div>
          </div>
          <div class="col-md-4">
            <div class="py-4 card_container">
              <div class="card__header___text">
                <div>
                  <h3 class="text-center our_branches__header">
                    {{ $t("text.sales.totalSupplies") }}
                  </h3>
                  <div class="mt-3 dealer__icon__wrapper">
                    <div class="text-center dealer__icon__div">
                      <div>
                        <img src="@/assets/img/supply-chain.png" width="40px" />
                      </div>
                    </div>
                  </div>
                  <h3 class="mt-2 text-center our_branches__header">
                    {{ this.totalSupplies }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="invoice-banner mt-3">
          <div>
            <div>
              <h5 class="deep-grey bold-span">
                {{ $t("text.sales.totalCost") }}
              </h5>
            </div>
            <div class="">
              <h5>
                <span class="currency"></span
                ><span class="amount-figures"
                  >{{ convertThousand(totalCostProductsSupplied) }}
                </span>
                <span class="grey-text bold-span">{{
                  group ? group.currency : ""
                }}</span>
              </h5>
            </div>
            <div class="grey-text"></div>
          </div>
          <div class="price_change_input_wrapper w-25">
            <vue-ctk-date-time-picker
              v-model="dateRange"
              :max-date="maxDate"
              :range="true"
              :autoClose="true"
              :locale="this.$root.$i18n.locale"
              :color="$store.getters.getDatePickerColor"
              format="YYYY-MM-DDTHH:mm:ss"
              formatted="DD/MM/YYYY"
              :label="$t('text.calendar.selectDate')"
            />
          </div>
          <div class="text-right">
            <div>
              <h5 class="deep-grey bold-span">
                {{ $t("text.sales.quantitySupplied") }}
              </h5>
            </div>
            <div>
              <h6 class="currency">
                <span class="amount-figures">{{
                  totalProductQuantitySupplied
                }}</span>
              </h6>
            </div>
          </div>
        </div>
      </div>

      <section class="pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div class="col-md-12 col-lg-12">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowTextWrap="true"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="80" field="index" headerText="#"></e-column>
                <e-column
                  width="150"
                  field="createdDate"
                  :headerText="$t('text.sales.date')"
                  :format="formatOptions"
                  type="date"
                ></e-column>
                <e-column
                  width="200"
                  field="branchName"
                  :headerText="$t('text.sales.stationName')"
                ></e-column>
                <e-column
                  width="150"
                  field="totalProductQuantitySupplied"
                  :headerText="$t('text.sales.quantitySupplied')"
                ></e-column>
                <e-column
                  width="150"
                  field="totalCostProductsSupplied"
                  :headerText="$t('text.sales.totalCost')"
                  format="N2"
                ></e-column>
                <e-column
                  width="200"
                  :template="statusTemplate"
                  :headerText="$t('text.sales.status')"
                ></e-column>
                <e-column
                  width="200"
                  :template="template"
                  :headerText="$t('text.sales.action')"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
    </MasterLayout>
    <!-- <RejectSupplyModal :rejectionReason="rejectionReason" /> -->
  </div>
</template>

<script>
import MasterLayout from "@/views/groupManagement/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import SupplyStatus from "@/components/Templates/NonWetProducts/supplyStatus";
// import RejectSupplyModal from "@/components/modals/dry-stock/rejectSupply";
import Template from "@/components/Templates/NonWetProducts/groupsupply";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Non Wet Products :: Epump Portal",
  name: "Users",
  components: {
    MasterLayout,
    TableLoader,
    // RejectSupplyModal,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      dateRange: {
        start: this.$moment().subtract(7, "days").format("YYYY-MM-DDTHH:mm:ss"),
        end: this.$moment().format("YYYY-MM-DDTHH:mm:ss"),
      },
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      group: null,
      backgroundUrl,
      salesCount: 0,
      rejectionReason: null,
      cardBackgroundUrl,
      showLoader: true,
      totalSupplies: 0,
      users: [],
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search", "ExcelExport", "PdfExport"],
      search: { operator: "contains", ignoreCase: true },
      template: function () {
        return {
          template: Template,
        };
      },
      statusTemplate: function () {
        return {
          template: SupplyStatus,
        };
      },

      totalCostProductsSupplied: 0,
      totalProductQuantitySupplied: 0,
    };
  },
  watch: {
    group(group) {
      if (group !== null) {
        this.getSupply();
      }
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.getSupply();
      }
    },
  },
  created() {
    this.$eventHub.$on("group", (group) => {
      this.group = group;
    });
    // this.$eventHub.$on("_rejectSupplyReason", ({ rejectionReason }) => {
    //   this.rejectionReason = rejectionReason;
    //   this.$modal.show("rejectSupply");
    // });

    this.$eventHub.$on("renderNonWetProductSupplies", () => {
      this.getSupply();
    });

    if (this.$route.query.groupId) {
      this.getSupply();
    }
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    openModal($modal) {
      this.$modal.show($modal);
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "Vehicles.pdf",
          };
          this.$refs.dataGrid.getColumns()[0].width = "80";
          this.$refs.dataGrid.getColumns()[1].width = "200";
          this.$refs.dataGrid.getColumns()[2].width = "140";
          this.$refs.dataGrid.getColumns()[3].width = "200";
          this.$refs.dataGrid.getColumns()[4].visible = false;
          this.$refs.dataGrid.getColumns()[5].visible = true;
          this.$refs.dataGrid.getColumns()[5].width = "120";
          this.$refs.dataGrid.getColumns()[6].width = "120";
          this.$refs.dataGrid.getColumns()[7].width = "120";
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          this.$refs.dataGrid.getColumns()[4].visible = false;
          this.$refs.dataGrid.getColumns()[5].visible = true;
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {},
    rowDataBound: function (args) {
      if (args.data["isSupplyAccepted"] === "Accepted") {
        args.row.cells[5].style.color = "green";
      } else {
        args.row.cells[5].style.color = "red";
      }
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getSupply() {
      this.showLoader = true;

      this.axios
        .get(
          `${configObject.apiBaseUrl}/NonWetProductSupply/Supplies/Group/${
            this.$route.query.groupId
              ? this.$route.query.groupId
              : this.group.id
          }/All?startDate=${this.dateRange.start}&endDate=${
            this.dateRange.end
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          this.totalSupplies = response.data.length;
          this.showLoader = false;
          this.totalCostProductsSupplied = response.data.reduce(
            (acc, cur) => (acc += cur.totalCostProductsSupplied),
            0
          );
          this.totalProductQuantitySupplied = response.data.reduce(
            (acc, cur) => (acc += cur.totalProductQuantitySupplied),
            0
          );
          response.data.forEach((el, i) => {
            el.rejectionReason = el.rejectionReason
              ? el.rejectionReason
              : "N/A";
            el.index = i + 1;
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>

<style></style>
